import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {BootstrapVue, BootstrapVueIcons, AlertPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-cool-select/dist/themes/bootstrap.css'
import './assets/styles/contest_table.scss'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import './third-party/gtm.js'
import './third-party/mauticTracking.js'
import Hotjar from 'vue-hotjar'
import VueHead from 'vue-head'

// Import the plugin here
import {Auth0Plugin} from './auth'
import localStorageHelper from '@/helpers/localStorageHelper'

import i18n from './i18n'
import './scss/custom.scss'
// Import the Auth0 configuration
const domain = process.env.VUE_APP_AUTH0_DOMAIN
const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID
const audience = process.env.VUE_APP_AUTH0_AUDIENCE

Vue.use(i18n)
// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState =>
  {
    if (appState && appState.targetUrl && appState.targetUrl !== '/login')
    {
      localStorageHelper.set('targetUrl', appState.targetUrl)
    }
    else
    {
      localStorageHelper.remove('targetUrl')
    }
    router.push('/login')
    /* router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : '/account'
    ) */
  },
  store
})

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(AlertPlugin)
Vue.use(Hotjar, {
  id: '2019662',
  snippetVersion: 6
})
Vue.use(VueHead)
Vue.component('VueSlider', VueSlider)

Vue.config.productionTip = false
const axios = require('axios').default
if (process.env.VUE_APP_API_BASE_URL)
{
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
}
else
{
  console.log('Not found VUE_APP_API_BASE_URL parameter')
}
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

const VueCookie = require('vue-cookie')
Vue.use(VueCookie)

if (navigator?.serviceWorker)
{
  navigator.serviceWorker.getRegistrations().then(function (registrations)
  {
    if (!registrations.length)
    {
      // console.log('No serviceWorker registrations found.')
    }
    else
    {
      for (const registration of registrations)
      {
        registration.unregister().then(function (boolean)
        {
          // console.log(
          //   (boolean ? 'Successfully unregistered' : 'Failed to unregister'), 'ServiceWorkerRegistration\n' +
          //   (registration.installing ? '  .installing.scriptURL = ' + registration.installing.scriptURL + '\n' : '') +
          //   (registration.waiting ? '  .waiting.scriptURL = ' + registration.waiting.scriptURL + '\n' : '') +
          //   (registration.active ? '  .active.scriptURL = ' + registration.active.scriptURL + '\n' : '') +
          //   '  .scope: ' + registration.scope + '\n'
          // )
        })
      }
    }
  })
}
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
